import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { JBP_URL } from '../shared/src';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
    providedIn: 'root',
})
export class JPBService {
    constructor(
        private http: HttpClient,
        private errorHandler: ErrorHandlerService
    ) { }

    private readonly JBP_API = `${JBP_URL}`;

    public createJPBFactors(data: any): Observable<any> {
        return this.http
            .post<any>(`${this.JBP_API}/jbpProfile/save`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllFactors(
        params: {

            countryId: number,
            channelId: number,
            accountId?: number
            pageIndex?: number,
            pageSize?: number,
            type?: string[]
        }
    ): Observable<any> {

        let queryParams = new HttpParams()

        if (params.pageIndex) {
            queryParams = queryParams.set('pageIndex', params.pageIndex)
        }
        if (params.pageSize) {
            queryParams = queryParams.set('pageSize', params.pageSize)
        }
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.type && params.type != null && params.type !== undefined && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPFactors`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllChannels(
        params: { countryId: any }
    ): Observable<any> {

        let queryParams = new HttpParams()

        if (params.countryId && params.countryId.length) {
            queryParams = queryParams.set('countryId', params.countryId.join(','))
        }

        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllChannels`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllAccounts(
        params: {
            countryId: any,
            channelId: any
        }
    ): Observable<any> {

        let queryParams = new HttpParams()

        if (params.countryId && params.countryId.length) {
            queryParams = queryParams.set('countryId', params.countryId.join(','))
        }
        if (params.channelId && params.channelId.length) {
            queryParams = queryParams.set('channelId', params.channelId.join(','))
        }

        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllAccounts`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public createScoringList(data: any): Observable<any> {
        console.log(data);
        return this.http
            .post<any>(`${this.JBP_API}/jbpProfile/scoringListSave`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public configureCountryStateScoring(data: any): Observable<any> {
        console.log(data);
        return this.http
            .post<any>(`${this.JBP_API}/jbpProfile/configureCountryStateScoring`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getCountryStateScoringConfig(countryId: number): Observable<any> {
        let queryParams = new HttpParams()
        if (countryId) {
            queryParams = queryParams.set('countryId', countryId)
        }
        return this.http
            .get<any>(`${this.JBP_API}/jbpProfile/getCountryStateScoringConfig`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllCountryStateRequired(countryId?: number[]): Observable<any> {
        let queryParams = new HttpParams()
        if (countryId && countryId.length) {
            queryParams = queryParams.set('countryId', countryId.join(','))
        }
        return this.http
            .get<any>(`${this.JBP_API}/jbpProfile/getAllCountriesStateIsRequired`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllJBPScoringList(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId: any,
            channelId: any,
            accountId?: any,
            year?: any,
            month?: any,
            stateId?: any,
            type?: string[]
        }
    ): Observable<any> {
        return this.http
            .post<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPScoringList`,
                params
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllJBPScoringListByFactors(

        params: { account_id: number, country_id: number, channel_id: number, scoring_month?: string | number, scoring_year?: number, state_id?: number, type?: string[] }

    ): Observable<any> {
        let queryParams = new HttpParams()
        if (params.country_id) {
            queryParams = queryParams.set('countryId', params.country_id)
        }
        if (params.channel_id) {
            queryParams = queryParams.set('channelId', params.channel_id)
        }
        if (params.account_id) {
            queryParams = queryParams.set('accountId', params.account_id)
        }
        if (params.scoring_month) {
            queryParams = queryParams.set('month', params.scoring_month)
        }
        if (params.scoring_year) {
            queryParams = queryParams.set('year', params.scoring_year)
        }
        if (params.state_id) {
            queryParams = queryParams.set('stateId', params.state_id)
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPScoringListByIds`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public deleteScoringList(params: { country_id: number, channel_id: number, account_id: number, scoring_month: number, scoring_year: number }): Observable<string> {
        let queryParams = new HttpParams()

        if (params.country_id) {
            queryParams = queryParams.set('countryId', params.country_id)
        }
        if (params.channel_id) {
            queryParams = queryParams.set('channelId', params.channel_id)
        }
        if (params.account_id) {
            queryParams = queryParams.set('accountId', params.account_id)
        }
        if (params.scoring_month) {
            queryParams = queryParams.set('month', params.scoring_month)
        }
        if (params.scoring_year) {
            queryParams = queryParams.set('year', params.scoring_year)
        }

        return this.http
            .delete<string>(`${this.JBP_API}/jbpProfile/deletescoring`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }



    public deleteFactorList(ids: any): Observable<string> {
        let queryParams = new HttpParams()
        if (ids && ids.length > 0) {
            queryParams = queryParams.set('id', ids);
        }
        return this.http
            .delete<string>(`${this.JBP_API}/jbpProfile/deletefactor`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllJBPFactorWeightedScoring(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId?: number,
            channelId?: number,
            accountId?: number,
            month?: number,
            year?: number,
            stateId?: number,
            type?: string[]
        }
    ): Observable<any> {

        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.month) {
            queryParams = queryParams.set('month', params.month)
        }
        if (params.year) {
            queryParams = queryParams.set('year', params.year)
        }
        if (params.stateId) {
            queryParams = queryParams.set('stateId', params.stateId);
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPFactorWeightedScoring`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getRetailerSkillWillRecommendation(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId?: number,
            channelId?: number,
            accountId?: number,
            month?: number,
            year?: number,
            stateId?: number,
            type?: string[]
        }
    ): Observable<any> {
        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.month) {
            queryParams = queryParams.set('month', params.month)
        }
        if (params.year) {
            queryParams = queryParams.set('year', params.year)
        }
        if (params.stateId) {
            queryParams = queryParams.set('stateId', params.stateId);
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getRetailerSkillWillRecommendation`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }



    //download excel template product
    public downloadExcelTemplate(countryId?: number) {
        let params: any = { responseType: 'blob' as 'json' };
        if (countryId) {
            params.params = { countryId };
        }
        return this.http
            .get(`${this.JBP_API}/JBPImportExport/downloadExcelTemplate`, params)
            .pipe(catchError(this.errorHandler.handleError));
    }


    //import product data
    public imporJBPSalesContribution(data: Record<string, any>): Observable<any[]> {
        return this.http
            .post<any[]>(`${this.JBP_API}/JBPImportExport/importData`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }


    public exportScoreList(params: {
        pageIndex: number,
        pageSize: number,
        countryId: any,
        channelId: any,
        accountId?: any,
        year?: any,
        month?: any,
        stateId?: any,
        type?: any
    }): Observable<any> {
        return this.http
            .post<Blob>(
                `${this.JBP_API}/JBPImportExport/ScoreList/downloadExcelReport`,
                params,
                {
                    responseType: 'blob' as 'json'
                }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }



    public uploadContractRepo(formData: FormData): Observable<any> {
        return this.http.post<any>(
            `${this.JBP_API}/jbpProfile/saveContractRepo`,
            formData
        ).pipe(catchError(this.errorHandler.handleError));
    }


    public getAllContractRepo(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId: number[] | null,
            channelId: number[] | null,
            accountId?: number[] | null,
            year?: number[] | null,
            month?: number[] | null,
            startDate?: string | null,
            endDate?: string | null,
            stateId?: number[] | null,
            docType?: string[] | null,
            tab?: string | null,
            repoType?: string[] | null,
            repo_level?: string | null
        }
    ): Observable<any> {
        return this.http
            .post<any>(
                `${this.JBP_API}/jbpProfile/getAllContractRepos`,
                params
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllContractRepoDocTypes(
        params: {
            countryId: number,
            channelId: number,
            accountId?: number
        }
    ): Observable<any> {

        let queryParams = new HttpParams()

        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllDocTypes`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllContractRepoFileTypes(
        params: {
            countryId: number,
            channelId: number,
            accountId?: number
        }
    ): Observable<any> {

        let queryParams = new HttpParams()

        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllFileTypes`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public deleteContractRepo(id: number): Observable<string> {
        let queryParams = new HttpParams()
        if (id) {
            queryParams = queryParams.set('id', id);
        }
        return this.http
            .delete<string>(`${this.JBP_API}/jbpProfile/deletecontractrepo`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public exportContractRepo(params: {
        pageIndex: number,
        pageSize: number,
        countryId: number[] | null,
        channelId: number[] | null,
        accountId?: number[] | null,
        year?: number[] | null,
        month?: number[] | null,
        startDate?: string | null,
        endDate?: string | null,
        stateId?: number[] | null,
        docType?: string[] | null,
        tab?: string | null,
        repoType?: string[] | null,
        repo_level?: string | null
    }
    ): Observable<any> {
        return this.http
            .post<Blob>(
                `${this.JBP_API}/JBPImportExport/ContractRepo/downloadExcelReport`,
                params,
                {
                    responseType: 'blob' as 'json'
                }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public exportFactorlist(params: {
        pageIndex: number,
        pageSize: number,
        countryId: number,
        channelId: number,
        type?: any

    }): Observable<any> {
        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.type && params.type.length) {
            queryParams = queryParams.set('type', params.type.join(','))
        }


        return this.http
            .post<Blob>(
                `${this.JBP_API}/JBPImportExport/FactorList/downloadExcelReport`,
                null,
                {
                    params: queryParams,
                    responseType: 'blob' as 'json'
                }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllJBPFactorScoresById(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId: number,
            channelId: number,
            accountId?: number,
            month?: number,
            startDate?: string,
            endDate?: string,
            year?: number,
            factorId?: number,
            stateId?: number,
            type?: any
        }
    ): Observable<any> {

        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.month) {
            queryParams = queryParams.set('month', params.month)
        }
        if (params.year) {
            queryParams = queryParams.set('year', params.year)
        }
        if (params.factorId) {
            queryParams = queryParams.set('factorId', params.factorId)
        }
        if (params.startDate) {
            queryParams = queryParams.set('fromDate', params.startDate);
        }

        if (params.endDate) {
            queryParams = queryParams.set('toDate', params.endDate);
        }
        if (params.stateId) {
            queryParams = queryParams.set('stateId', params.stateId)
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }

        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPFactorScoresById`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public createSalesContribution(data: any): Observable<any> {
        return this.http
            .post<any>(`${this.JBP_API}/jbpProfile/saveSalesContribution`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }


    public deleteSalesContribution(id: number): Observable<string> {
        let queryParams = new HttpParams()
        if (id) {
            queryParams = queryParams.set('id', id);
        }
        return this.http
            .delete<string>(`${this.JBP_API}/jbpProfile/deleteSalesContribution`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllSalesContributions(
        params: {

            countryId?: any,
            channelId?: any,
            accountId?: any,
            stateId?: any,
            pageIndex?: number,
            pageSize?: number,
        }
    ): Observable<any> {


        let queryParams = new HttpParams()

        if (params.pageIndex) {
            queryParams = queryParams.set('pageIndex', params.pageIndex)
        }
        if (params.pageSize) {
            queryParams = queryParams.set('pageSize', params.pageSize)
        }
        if (params.countryId && params.countryId.length) {
            queryParams = queryParams.set('countryId', params.countryId.join(','))
        }
        if (params.channelId && params.channelId.length) {
            queryParams = queryParams.set('channelId', params.channelId.join(','))
        }
        if (params.accountId && params.accountId.length) {
            queryParams = queryParams.set('accountId', params.accountId.join(','))
        }
        if (params.stateId && params.stateId.length) {
            queryParams = queryParams.set('stateId', params.stateId.join(','))
        }


        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllSalesContributions`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getALLFactorChannelTypes(): Observable<any> {

        let queryParams = new HttpParams()



        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getALLFactorChannelTypes`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }



    public getAllAssessmentTypes(): Observable<any> {

        let queryParams = new HttpParams()

        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllAssessmentTypes`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public createJBPRetailerCutOff(data: any): Observable<any> {
        return this.http
            .post<any>(`${this.JBP_API}/jbpProfile/saveJBPRetailerCutOff`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }


    public deleteJBPRetailerCutOff(id: number): Observable<string> {
        let queryParams = new HttpParams()
        if (id) {
            queryParams = queryParams.set('id', id);
        }
        return this.http
            .delete<string>(`${this.JBP_API}/jbpProfile/deleteJBPRetailerCutOff`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllJBPRetailerCutOffs(
        params: {

            countryId?: any,
            pageIndex?: number,
            pageSize?: number,
        }
    ): Observable<any> {


        let queryParams = new HttpParams()

        if (params.pageIndex) {
            queryParams = queryParams.set('pageIndex', params.pageIndex)
        }
        if (params.pageSize) {
            queryParams = queryParams.set('pageSize', params.pageSize)
        }
        if (params.countryId && params.countryId.length) {
            queryParams = queryParams.set('countryId', params.countryId.join(','))
        }



        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPRetailerCutOffs`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }




    public createScoringListByStore(data: any): Observable<any> {
        console.log(data);
        return this.http
            .post<any>(`${this.JBP_API}/jbpProfile/scoringListSaveByStore`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }


    public deleteScoringByStore(params: { country_id: number, channel_id: number, account_id: number, store_id: number, scoring_month: number, scoring_year: number }): Observable<string> {
        let queryParams = new HttpParams()

        if (params.country_id) {
            queryParams = queryParams.set('countryId', params.country_id)
        }
        if (params.channel_id) {
            queryParams = queryParams.set('channelId', params.channel_id)
        }
        if (params.account_id) {
            queryParams = queryParams.set('accountId', params.account_id)
        }
        if (params.store_id) {
            queryParams = queryParams.set('storeId', params.store_id)
        }
        if (params.scoring_month) {
            queryParams = queryParams.set('month', params.scoring_month)
        }
        if (params.scoring_year) {
            queryParams = queryParams.set('year', params.scoring_year)
        }

        return this.http
            .delete<string>(`${this.JBP_API}/jbpProfile/deleteScoringByStore`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllJBPScoringListByStore(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId: any,
            channelId: any,
            accountId?: any,
            year?: any,
            month?: any,
            stateId?: any,
            type?: string[],
            storeId?: any,
            hasStoreOnly?: boolean
        }
    ): Observable<any> {
        return this.http
            .post<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPScoringListByStore`,
                params
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllJBPScoringListByFactorsByStore(

        params: { account_id: number, country_id: number, channel_id: number, scoring_month?: string | number, scoring_year?: number, state_id?: number, type?: string[], store_id?: any, hasStoreOnly?: boolean }

    ): Observable<any> {
        let queryParams = new HttpParams()
        if (params.country_id) {
            queryParams = queryParams.set('countryId', params.country_id)
        }
        if (params.channel_id) {
            queryParams = queryParams.set('channelId', params.channel_id)
        }
        if (params.account_id) {
            queryParams = queryParams.set('accountId', params.account_id)
        }
        if (params.scoring_month) {
            queryParams = queryParams.set('month', params.scoring_month)
        }
        if (params.scoring_year) {
            queryParams = queryParams.set('year', params.scoring_year)
        }
        if (params.state_id) {
            queryParams = queryParams.set('stateId', params.state_id)
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        if (params.store_id) {
            const storeIdValue = Array.isArray(params.store_id) ? params.store_id.join(',') : params.store_id;
            queryParams = queryParams.set('storeId', storeIdValue.toString());
        }
        if (params.hasStoreOnly) {
            queryParams = queryParams.set('hasStoreOnly', 'true')
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPScoringListByFactorIdsStore`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllJBPFactorWeightedScoringByStore(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId?: number,
            channelId?: number,
            accountId?: number,
            month?: number,
            year?: number,
            stateId?: number,
            type?: string[],
            storeId?: number,
            hasStoreOnly?: boolean
        }
    ): Observable<any> {

        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.month) {
            queryParams = queryParams.set('month', params.month)
        }
        if (params.year) {
            queryParams = queryParams.set('year', params.year)
        }
        if (params.stateId) {
            queryParams = queryParams.set('stateId', params.stateId);
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        if (params.storeId) {
            queryParams = queryParams.set('storeId', params.storeId);
        }
        if (params.hasStoreOnly) {
            queryParams = queryParams.set('hasStoreOnly', 'true');
        }

        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPFactorWeightedScoringByStore`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getAllJBPFactorScoresByIdStore(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId: number,
            channelId: number,
            accountId?: number,
            month?: number,
            startDate?: string,
            endDate?: string,
            year?: number,
            factorId?: number,
            stateId?: number,
            type?: any,
            storeId?: number,
            hasStoreOnly?: boolean
        }
    ): Observable<any> {

        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.month) {
            queryParams = queryParams.set('month', params.month)
        }
        if (params.year) {
            queryParams = queryParams.set('year', params.year)
        }
        if (params.factorId) {
            queryParams = queryParams.set('factorId', params.factorId)
        }
        if (params.startDate) {
            queryParams = queryParams.set('fromDate', params.startDate);
        }

        if (params.endDate) {
            queryParams = queryParams.set('toDate', params.endDate);
        }
        if (params.stateId) {
            queryParams = queryParams.set('stateId', params.stateId)
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        if (params.storeId) {
            queryParams = queryParams.set('storeId', params.storeId);
        }
        if (params.hasStoreOnly) {
            queryParams = queryParams.set('hasStoreOnly', 'true');
        }

        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPFactorScoresByIdStore`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }




    public exportStoreScoreList(params: {
        pageIndex: number,
        pageSize: number,
        countryId: any,
        channelId: any,
        accountId?: any,
        year?: any,
        month?: any,
        stateId?: any,
        type?: any,
        storeId?: any
    }): Observable<any> {
        return this.http
            .post<Blob>(
                `${this.JBP_API}/JBPImportExport/ScoreListByStore/downloadExcelReport`,
                params,
                {
                    responseType: 'blob' as 'json'
                }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public getStoreScoreRetailerSkillWillRecommendation(
        params: {
            pageIndex: number,
            pageSize: number,
            countryId?: number,
            channelId?: number,
            accountId?: number,
            month?: number,
            year?: number,
            stateId?: number,
            type?: string[]
        }
    ): Observable<any> {
        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.month) {
            queryParams = queryParams.set('month', params.month)
        }
        if (params.year) {
            queryParams = queryParams.set('year', params.year)
        }
        if (params.stateId) {
            queryParams = queryParams.set('stateId', params.stateId);
        }
        if (params.type && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getStoreScoreRetailerSkillWillRecommendation`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }






    public createJPBFactorsByStore(data: any): Observable<any> {
        return this.http
            .post<any>(`${this.JBP_API}/jbpProfile/saveFactorsByStore`, data)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllFactorsByStore(
        params: {

            countryId: number,
            channelId: number,
            accountId?: number
            pageIndex?: number,
            pageSize?: number,
            type?: string[]
        }
    ): Observable<any> {

        let queryParams = new HttpParams()

        if (params.pageIndex) {
            queryParams = queryParams.set('pageIndex', params.pageIndex)
        }
        if (params.pageSize) {
            queryParams = queryParams.set('pageSize', params.pageSize)
        }
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.accountId) {
            queryParams = queryParams.set('accountId', params.accountId)
        }
        if (params.type && params.type != null && params.type !== undefined && params.type.length > 0) {
            queryParams = queryParams.set('type', params.type.toString())
        }
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllJBPFactorsByStore`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public exportFactorlistByStore(params: {
        pageIndex: number,
        pageSize: number,
        countryId: number,
        channelId: number,
        type?: any

    }): Observable<any> {
        let queryParams = new HttpParams()
            .set('pageIndex', params.pageIndex)
            .set('pageSize', params.pageSize)
        if (params.countryId) {
            queryParams = queryParams.set('countryId', params.countryId)
        }
        if (params.channelId) {
            queryParams = queryParams.set('channelId', params.channelId)
        }
        if (params.type && params.type.length) {
            queryParams = queryParams.set('type', params.type.join(','))
        }


        return this.http
            .post<Blob>(
                `${this.JBP_API}/JBPImportExport/FactorListByStore/downloadExcelReport`,
                null,
                {
                    params: queryParams,
                    responseType: 'blob' as 'json'
                }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }


    public deleteFactorListByStore(ids: any): Observable<string> {
        let queryParams = new HttpParams()
        if (ids && ids.length > 0) {
            queryParams = queryParams.set('id', ids);
        }
        return this.http
            .delete<string>(`${this.JBP_API}/jbpProfile/deletefactorByStore`, { params: queryParams })
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getALLFactorChannelTypesByStore(): Observable<any> {

        let queryParams = new HttpParams()



        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getALLFactorChannelTypesByStore`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllAssessmentTypesByStore(): Observable<any> {

        let queryParams = new HttpParams()

        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getAllAssessmentTypesByStore`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getStoreGradeRecommendations(storeGrade: string): Observable<any> {
        let queryParams = new HttpParams().set('storeGrade', storeGrade);
        return this.http
            .get<any>(
                `${this.JBP_API}/jbpProfile/getStoreGradeRecommendations`, { params: queryParams }
            )
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllStoreGradeRecommendations(): Observable<any> {
        return this.http
            .get<any>(`${this.JBP_API}/jbpProfile/getAllStoreGradeRecommendations`)
            .pipe(catchError(this.errorHandler.handleError));
    }

    public getAllAgencyTypes(): Observable<any> {
        return this.http
            .get<any>(`${this.JBP_API}/jbpProfile/getAllAgencyTypes`)
            .pipe(catchError(this.errorHandler.handleError));
    }

}